export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13209.3bd711ab.jpg";